import {
  SET_ADMISSION_INSTANCES,
} from '../actions/actionTypes';

const initialState = {
  loading: true,
  error: null,
};

export default function admissionInstances(state = initialState, action) {
  switch (action.type) {
    case SET_ADMISSION_INSTANCES: {
      const { data } = action.payload;
      return {
        ...state,
        ...data,
      };
    }
    default:
      return state;
  }
}
